var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 11,
    viewBox: "0 0 42 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5177 9.1863C39.621 9.72883 40.1446 10.0849 40.6871 9.98152C41.2297 9.87817 41.5857 9.35459 41.4823 8.81206C40.3725 2.98594 35.4783 0.351472 30.9394 0.626836C27.5462 0.832696 24.237 2.67827 22.7776 6.04759C21.5163 4.2078 19.3991 3.00089 17 3.00089C14.3075 3.00089 11.97 4.5211 10.799 6.75003C9.88202 5.67936 8.52024 5.00089 7 5.00089C4.23858 5.00089 2 7.23947 2 10.0009H4C4 8.34404 5.34315 7.00089 7 7.00089C8.65685 7.00089 10 8.34404 10 10.0009H12C12 7.23947 14.2386 5.00089 17 5.00089C19.7614 5.00089 22 7.23947 22 10.0009H24C24 5.3809 27.3556 2.84794 31.0606 2.62317C34.7717 2.39802 38.6275 4.51305 39.5177 9.1863Z",
    fill: "url(#paint0_linear_14089_62462)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.5C0.5 10.2239 0.723858 10 1 10H5C5.27614 10 5.5 10.2239 5.5 10.5C5.5 10.7761 5.27614 11 5 11H1C0.723858 11 0.5 10.7761 0.5 10.5Z",
    fill: "url(#paint1_linear_14089_62462)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.5C7.5 10.2239 7.72386 10 8 10H14C14.2761 10 14.5 10.2239 14.5 10.5C14.5 10.7761 14.2761 11 14 11H8C7.72386 11 7.5 10.7761 7.5 10.5Z",
    fill: "url(#paint2_linear_14089_62462)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 10.5C19.5 10.2239 19.7239 10 20 10H26C26.2761 10 26.5 10.2239 26.5 10.5C26.5 10.7761 26.2761 11 26 11H20C19.7239 11 19.5 10.7761 19.5 10.5Z",
    fill: "url(#paint3_linear_14089_62462)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14089_62462",
    x1: 32.26,
    y1: 0.605878,
    x2: -4.96626,
    y2: 15.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B860",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14089_62462",
    x1: 0.777778,
    y1: 10.5,
    x2: 3.81499,
    y2: 8.43262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB868",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F79337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14089_62462",
    x1: 7.88889,
    y1: 10.5,
    x2: 11.1498,
    y2: 7.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB868",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F79337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14089_62462",
    x1: 19.8889,
    y1: 10.5,
    x2: 23.1498,
    y2: 7.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB868",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F79337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28928",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.ef00f950b15c7234b758fc930b4243dd.svg";
export { ForwardRef as ReactComponent };